import React, { ReactElement } from 'react';

export const renderHTML = (rawHTML: string): ReactElement =>
  React.createElement('div', {
    dangerouslySetInnerHTML: { __html: rawHTML },
    tabIndex: 3,
    className: 'focus:outline-none',
  });
